module.exports = __webpack_public_path__ + "static/media/square.7ccccfb5.svg";